import styled from 'styled-components';
import { Breakpoints, FontWeight } from '../../../../styled/constants';
import { FlexBetween } from '../../../../styled/common';

export const AdvTitleNavRow = styled(FlexBetween)`
  gap: 80px;
  width: 100%;
  @media (max-width: ${Breakpoints.smallDesktop}px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const AdvTitle = styled.h2`
  font-size: 32px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-weight: ${FontWeight.thin};
  padding: 0 15px;
  margin: 0;
  @media (max-width: ${Breakpoints.smallDesktop}px) {
    font-size: 24px;
  }
  @media (max-width: ${Breakpoints.tablet}px) {
    margin-bottom: 20px;
  }
`;

export const NavWithButtonsWrapper = styled(FlexBetween)`
  position: relative;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
  width: 100%;
`;

export const NavScrollWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  overflow-x: auto;
  padding: 0 2px;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 50px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    overflow: hidden;
    overflow-x: auto;
  }
`;

export const AdvNavBar = styled.div`
  display: flex;
  gap: 10px;
  padding: 5px;
  white-space: nowrap;
  min-width: max-content;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: visible;

  @media (max-width: ${Breakpoints.tablet}px) {
    border-radius: 50px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    margin: 0 15px;
  }
`;

export const AdvNavButton = styled.button<{ active: boolean }>`
  padding: 10px 15px;
  border-radius: 20px;
  background-color: ${({ active }) => (active ? '#2d2e2f' : 'transparent')};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  border: none;
  font-size: 14px;
  font-weight: ${FontWeight.medium};
  -webkit-tap-highlight-color: transparent;

  @media (min-width: ${Breakpoints.tablet}px) {
    &:hover {
      background-color: #2d2e2f;
    }
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;

  @media (max-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const ScrollArrow = styled.button<{ right?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(210, 210, 210, 0.5);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 4px;
  pointer-events: auto;

  &::before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url('/static/images/pasha/swipe-icon-white.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    transform: ${({ right }) => (right ? 'rotate(180deg)' : 'none')};
  }
`;

export const ScrollArrowLeft = styled(ScrollArrow)`
  left: 5px;
`;

export const ScrollArrowRight = styled(ScrollArrow)`
  right: 5px;
`;
